import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';

import { useTranslation } from 'react-i18next';

import { SettingService } from 'features/userSettings';
import { isHasAccess } from 'features/validateAccess';

import { AccountStatus } from 'entities/account';

import { pathKeys } from 'shared/lib/react-router';
import { LinkButton } from 'shared/ui/LinkButton';

import { CREATE_ACCOUNT } from '../../AccountList.permissions';
import { getAccountTabs, getDefaultAccountStatus } from '../../lib';
import { AccountList } from '../AccountList';

import styles from './AccountTabs.module.scss';

const AccountTabs: React.FC = () => {
  const { t } = useTranslation('Account');
  const [page, setPage] = useState(1);

  const [activeKey, setActiveKey] = useState<AccountStatus>(getDefaultAccountStatus());

  const onChangeStatus = (status: string) => {
    setPage(1);
    setActiveKey(status as AccountStatus);
    SettingService.saveLocalSetting('selectedAccountTab', status, 'sessionStorage');

    setTimeout(() => {
      document.querySelector('main')?.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  const hideCreateButton = !isHasAccess(CREATE_ACCOUNT);

  return (
    <div className={styles.tabs}>
      <div className={styles.headerWrapper}>
        <div className={styles.header}>
          <Typography.Title level={3}>{t('AccountsPage.heading')}</Typography.Title>
          {!hideCreateButton && (
            <LinkButton
              linkProps={{ to: pathKeys.account.create() }}
              buttonProps={{ type: 'primary' }}
              data-testid="create-button"
            >
              {t('AccountsPage.createButton.label')}
            </LinkButton>
          )}
        </div>
        <Tabs activeKey={activeKey} onChange={onChangeStatus} tabBarGutter={4} items={getAccountTabs(t)} type="card" />
      </div>
      <AccountList page={page} setPage={setPage} status={activeKey} />
    </div>
  );
};

export default AccountTabs;
